import {Page} from "_page/Page";
import {VStack} from "_ui/Box";
import {observer} from "@legendapp/state/react";
import {Outlet} from "react-router-dom";
import {TopBar} from "_pages/service/queue/components/top-bar";

const Layout = observer(() => {
    return (
        <Page>
            <VStack wFull>
                <TopBar/>

                <Outlet/>
            </VStack>
        </Page>
    );
});

export default Layout;
